import React, { useEffect, useState } from 'react';

const TaskToolbar = ({ filters, setFilters, totalTasks = 0, businessUnits = [] }) => {
    const [isMobile, setIsMobile] = useState(false);
    const [showFilters, setShowFilters] = useState(true);

    useEffect(() => {
        const update = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            setShowFilters(!mobile); // default open on desktop, collapsed on mobile
        };
        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    return (
        <div className="task-toolbar-group">
            {isMobile && (
                <button
                    type="button"
                    className="task-filter-toggle"
                    onClick={() => setShowFilters((prev) => !prev)}
                >
                    {showFilters ? 'Hide Filters' : 'Show Filters'}
                </button>
            )}

            {(!isMobile || showFilters) && (
                <>
                    <div className="task-filter-control">
                        <label>Mode</label>
                        <select name="mode" value={filters.mode} onChange={handleChange}>
                            <option value="all">All Tasks</option>
                            <option value="simple">Simple Tasks</option>
                            <option value="structured">Scheduled Tasks</option>
                        </select>
                        <i className="fa fa-chevron-down"></i>
                    </div>

                    <div className="task-filter-control">
                        <label>Status</label>
                        <select name="status" value={filters.status} onChange={handleChange}>
                            <option value="incomplete">Incomplete</option>
                            <option value="completed">Completed</option>
                            <option value="all">All</option>
                        </select>
                        <i className="fa fa-chevron-down"></i>
                    </div>

                    <div className="task-filter-control" style={{ minWidth: '220px' }}>
                        <label>Search</label>
                        <input
                            type="text"
                            name="search"
                            value={filters.search}
                            onChange={handleChange}
                            placeholder="Search title or description"
                            className="form-control input-sm"
                        />
                    </div>

                    <div className="task-filter-control">
                        <label>Business Unit</label>
                        <select
                            name="business_unit_id"
                            value={filters.business_unit_id}
                            onChange={handleChange}
                        >
                            <option value="">All Units</option>
                            {businessUnits.map((unit) => {
                                const id = unit.id ?? unit.unit_id;
                                return (
                                    <option key={id} value={id !== undefined && id !== null ? String(id) : ''}>{unit.title || unit.name || `Unit ${id}`}</option>
                                );
                            })}
                        </select>
                        <i className="fa fa-chevron-down"></i>
                    </div>
                </>
            )}

            <div className="task-count-pill">
                Showing {totalTasks} {totalTasks === 1 ? 'task' : 'tasks'}
            </div>
        </div>
    );
};

export default TaskToolbar;
